export const contactChannels = [
  {
    icon: "ri-whatsapp-line",
    label: "WhatsApp",
    value: "54 99654-2326",
    note: "Atendimento rápido pelo WhatsApp",
    href: "https://wa.me/5554996542326",
    external: true,
    tone: "secondary",
  },
  {
    icon: "ri-mail-send-line",
    label: "E-mail comercial",
    value: "vendas@nxhost.com.br",
    note: "Para orçamentos, dúvidas e propostas",
    href: "mailto:vendas@nxhost.com.br",
    external: false,
    tone: "primary",
  },
  {
    icon: "ri-time-line",
    label: "Horário de atendimento",
    value: "Segunda a sexta",
    note: "Atendimento em horário comercial",
    href: "",
    external: false,
    tone: "accent",
  },
  {
    icon: "ri-customer-service-2-line",
    label: "Suporte",
    value: "Equipe especializada",
    note: "Ajuda para clientes e projetos",
    href: "",
    external: false,
    tone: "secondary",
  },
];

export const contactSubjects = [
  "Hospedagem de sites",
  "VPS e servidores",
  "Criação de sites",
  "Lojas virtuais",
  "Sistemas web",
  "Domínios",
  "Suporte",
  "Outro",
];